var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"e-toolbar-items":""}},[(this.data.result === 0)?_c('div',[_c('div',{attrs:{"id":"detail"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.data.detail))])]):_c('div',[_c('span',[_vm._v("\n            "+_vm._s(_vm.data.detail)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }